export default "__VITE_ASSET__CP5zRfdx__"